import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { AxiosHeaders } from "axios";

/** Safari + axios may keep `application/json` on FormData uploads unless Content-Type is cleared. */
export function clearContentTypeForFormData(config: InternalAxiosRequestConfig): void {
    if (!(config.data instanceof FormData)) {
        return;
    }

    const headers = config.headers;
    if (headers instanceof AxiosHeaders) {
        headers.delete("Content-Type");
        headers.delete("content-type");
        return;
    }

    if (headers && typeof headers === "object") {
        delete (headers as Record<string, unknown>)["Content-Type"];
        delete (headers as Record<string, unknown>)["content-type"];
    }
}

export function setupFormDataMultipartInterceptor(api: AxiosInstance): void {
    api.interceptors.request.use((config) => {
        clearContentTypeForFormData(config);
        return config;
    });
}
